import firebase from 'firebase/app'
import 'firebase/firestore'
import "firebase/auth";

import EventBus from "@/EventBus";

import axios from 'axios';



var firebaseConfig = window.my_firebase_config;

// Get a Firestore instance
const fb = firebase
.initializeApp(firebaseConfig)


export const firebaseSigninTg = () => {
    axios.post('/api/app/v1/google/firestore/token',{}).then((result) => {
        let {data} = result;
        firebase.auth().signInWithCustomToken(data.data).catch(function() {
            // Handle Errors here.
            /*var errorCode = error.code;
            var errorMessage = error.message;*/
        });
    });
}

export const firebaseSignoutTg = () => {
    firebase.auth().signOut().then(function() {
        // Sign-out successful.
        EventBus.$emit('firebase:signout',{})
    }).catch(function() {
        // An error happened.
    });
}

firebase.auth().onAuthStateChanged((user) => {
    EventBus.$emit('firebase:auth',{user})
}, () => {

});



export const db = fb.firestore()
// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint}
